<rlst-modal header="View Photos" (closeModal)="onClose()">
  <div class="info">
    <div>
      <span class="address">{{ data.propertyData | rlstAddress }}</span>
      <button
        class="btn-custom btn-small print-button d-none d-md-flex"
        (click)="printPhotos()"
      >
        <i class="fas fa-print fa-fw" aria-hidden="true"></i>
        Print Photos
      </button>
    </div>
    <hr class="horizontal-separator"/>
    <p class="counter">{{ getCounterLabel() }}</p>
  </div>
  <div class="gallery" *ngIf="!data.isMobile">
    <div class="swiper-container gallery-top">
      <swiper-container
        #swiper
        init="false"
        slides-per-view="1"
        space-between="30"
        (swiperslidechange)="onSlideChange()"
        (swiperafterinit)="onMainSwiperReady($event)"
        class="my-swiper"
      >
        <swiper-slide *ngFor="let imageUrl of data.imageSource">
          <img [src]="imageUrl"/>
        </swiper-slide>
      </swiper-container>
      <div class="swiper-button-prev prev-main">
        <button class="swiper-button btn-icon-primary" (click)="slidePrev()" [disabled]="disablePrevSlide">
          <i class="fas fa-chevron-left"></i>
          <span class="sr-only">Left</span>
        </button>
      </div>
      <div class="swiper-button-next next-main">
        <button class="swiper-button btn-icon-primary" (click)="slideNext()" [disabled]="disableNextSlide">
          <i class="fas fa-chevron-right"></i>
          <span class="sr-only">Right</span>
        </button>
      </div>
    </div>

    <div class="swiper-container gallery-thumbs">
      <swiper-container
        #swiperGalleryThumbs
        init="false"
        slides-per-view="10"
        space-between="10"
        free-mode="true"
        watch-slides-progress="true"
        (swiperslidechange)="onSlideChange()"
        (swiperafterinit)="onThumbnailSwiperReady($event)"
        (swiperslidesupdated)="onThumbnailSwiperReady($event)"
        class="my-swiper"
      >
        <swiper-slide
          class="swiper-slide"
          *ngFor="let imageUrl of data.imageSource; let idx = index"
        >
          <img [src]="imageUrl" (click)="goToSlide(idx)"/>
        </swiper-slide>
      </swiper-container>
      <div class="swiper-button-prev prev-thumbs">
        <button class="swiper-button btn-icon-primary" (click)="slidePrevGalleryThumbs()"
                [disabled]="disablePrevThumbsSlide">
          <i class="fas fa-chevron-left"></i>
          <span class="sr-only">Left</span>
        </button>
      </div>
      <div class="swiper-button-next next-thumbs">
        <button class="swiper-button btn-icon-primary" (click)="slideNextGalleryThumbs()"
                [disabled]="disableNextThumbsSlide">
          <i class="fas fa-chevron-right"></i>
          <span class="sr-only">Right</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="data.isMobile">
    <div *ngFor="let imageUrl of data.imageSource">
      <img [src]="imageUrl" alt="property" class="w-100 img-mobile"/>
    </div>
  </div>
</rlst-modal>
